import PropTypes from 'prop-types'

import dishIngredientPropType from './dish-ingredient-prop-type'

const ingredientsGroupedByFieldNamePropType = PropTypes.shape({
  mainIngredients: PropTypes.arrayOf(dishIngredientPropType),
  additionalIngredients: PropTypes.arrayOf(dishIngredientPropType),
  choiceIngredients: PropTypes.arrayOf(dishIngredientPropType),
  blacklistedIngredients: PropTypes.arrayOf(dishIngredientPropType),
})

export default ingredientsGroupedByFieldNamePropType
